import Constants from "~/helpers/enums/Constants";
import getUserUpdateService from "~/services/userUpdateService";

const getUserUpdate = (id, resp) => (dispatch) => {
	getUserUpdateService.putUserUpdate(id, resp).then(({ data }) => {
		dispatch({ type: Constants.USER_UPDATE, payload: { userUpdate: data } });
	});
};
export default { getUserUpdate };
